import {useMemo} from 'react';

import type {
  IUseCommoditySelectionSubStepParams,
  IUseCommoditySelectionSubStepResult,
} from '../productionInfo.types';

export function lshUseCommoditySelectionSubStep({
  selectedCommodityIds,
  isSavingCommodities,
  setCommodityError,
  setSelectedCommodityIds,
}: IUseCommoditySelectionSubStepParams): IUseCommoditySelectionSubStepResult {
  const selectedCommoditySet = useMemo(
    () => new Set(selectedCommodityIds),
    [selectedCommodityIds],
  );

  const handleToggleCommodity = (commodityId: number) => {
    if (isSavingCommodities) return;

    setCommodityError(null);
    setSelectedCommodityIds((current) => {
      if (current.includes(commodityId)) {
        return current.filter((id) => id !== commodityId);
      }

      return [...current, commodityId];
    });
  };

  return {
    selectedCommoditySet,
    handleToggleCommodity,
  };
}
